import { styled } from '@mui/material/styles';
import ListItem from '@mui/material/ListItem/ListItem';
import Typography from '@mui/material/Typography/Typography';

import { devices } from 'styles';
import { colors } from 'styles/colors';

export const ListSectionTitle = styled(Typography)`
  margin-bottom: 48px;
  font-weight: 700;
  font-size: 24px;
  line-height: 120%;
  color: ${colors.textPrimary};

  @media (${devices.sm}) {
    font-size: 32px;
  }

  @media (${devices.md}) {
    font-size: 36px;
  }
`;

export const ListSectionListItem = styled(ListItem)`
  color: ${colors.textPrimary};
  padding: 8px 0;
  line-height: 150%;
  font-size: 16px;

  &:first-of-type {
    padding-top: 0;
  }

  &:last-of-type {
    padding-bottom: 0;
  }

  @media (${devices.sm}) {
    line-height: 140%;
    font-size: 18px;
  }
`;
